import { render } from "./wishlistView.vue?vue&type=template&id=34d0d59b"
import script from "./wishlistView.vue?vue&type=script&lang=js"
export * from "./wishlistView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__